// extracted by mini-css-extract-plugin
export default {"page":"Portfolio_page__o33VN"};